import { state } from '../core/state.js';
import { socket } from '../core/socket.js';
import { t, i18n } from '../core/i18n.js';
import { chaosNotify } from '../utils/alerts.js';
import { startScramble } from './sidebar.js';

export function basculerAffichage(mode) {
    const dash = document.getElementById('dashboard-accueil');
    const chat = document.getElementById('chat-view');
    const inputArea = document.querySelector('.input-area');

    if (mode === 'dashboard') {
        if (dash) dash.style.display = 'flex';
        if (chat) chat.style.display = 'none';
        if (inputArea) inputArea.style.display = 'none';
    } else {
        if (dash) dash.style.display = 'none';
        if (chat) chat.style.display = 'flex';
        if (inputArea) inputArea.style.display = 'block';
    }
}

export function updateDashboard() {
    const pseudoDash = document.querySelector('.mon-pseudo-dash');
    if (pseudoDash) pseudoDash.innerText = state.monPseudo; // On pioche dans le state

    updateClock();
    socket.emit('demander-stats-globales');
    const phraseEl = document.getElementById('phrase-aleatoire');
    if (phraseEl) {
        const phrasesChaos = i18n.tArray('dashboard.chaos_phrases');
        const index = Math.floor(Math.random() * phrasesChaos.length);
        const phraseSysteme = "> " + (phrasesChaos[index] || '');

        phraseEl.innerHTML = `
            <div class="terminal-welcome">
                <p>${phraseSysteme}</p>
                <div class="terminal-hint">
                    <span class="hint-tag">${t('dashboard.hint_label')}</span><br>
                    ${t('dashboard.hint')}
                </div>
            </div>
        `;
    }

    const newsContainer = document.getElementById('news-chaos');
    if (newsContainer) {
        const newsGlitch = i18n.tArray('dashboard.news_glitch');
        const uneNews = newsGlitch[Math.floor(Math.random() * newsGlitch.length)] || '';
        newsContainer.innerHTML = `
            <li class="news-item">
                <span class="tag-tag-stable">${t('dashboard.news_stable_tag')}</span>
                ${t('dashboard.news_stable_text')}
            </li>
            <li class="news-item">
                <span class="tag-tag-glitch">${t('dashboard.news_glitch_tag')}</span>
                ${t('dashboard.news_glitch_text')}
            </li>
            <li class="news-item">
                <span class="tag-tag-nouveau">${t('dashboard.news_new_tag')}</span>
                ${uneNews}
            </li>
        `;
    }
}

export function ouvrirAccueil() {
    basculerAffichage('dashboard');
    updateDashboard();

    const channels = document.getElementById('channels-column');
    if (channels) channels.style.display = 'none';
    if (channels) channels.classList.remove('open');
    
    if (typeof window.majPushChannels === 'function') window.majPushChannels();
    if (typeof window.nettoyerHeaderGlobal === 'function') window.nettoyerHeaderGlobal();
    
    state.salonActuelID = null; // Sync state
    socket.emit('demander-liste-maj');
}

export async function autoDestruction() {
    const main = document.body;
    main.classList.add('shake-anim');
    socket.emit('clic-auto-destruction');
    setTimeout(async () => {
        main.classList.remove('shake-anim');
        await chaosNotify(t('confirm.destruct_cancel'));
    }, 2000);
}

export function updateClock() {
    const clockEl = document.getElementById('clock');
    if (clockEl) {
        const now = new Date();
        const timeStr = now.toLocaleTimeString('fr-FR');
        clockEl.innerHTML = `<span style="color: var(--text-muted); font-size: 0.9rem;">${t('dashboard.clock_label')}</span>
                             <span style="color: var(--theme-primary); font-family: 'Orbitron', monospace; letter-spacing: 2px;">${timeStr}</span>`;
    }
}

export function initDashboard() {
    // Lance l'horloge toutes les secondes
    setInterval(updateClock, 1000);

    // Initialisation de l'effet de glitch sur le survol
    document.querySelectorAll(".scramble-text").forEach(title => {
        title.dataset.value = title.innerText;
        title.onmouseover = startScramble;
    });

    // Écouteur pour la destruction globale
    socket.on('update-global-destruction', (count) => {
        const countEl = document.getElementById('stat-destruction');
        if (countEl) {
            countEl.innerText = count;
            countEl.style.color = "#ff4b2b";
            setTimeout(() => { countEl.style.color = ""; }, 500);
        }
    });
}

setInterval(() => {
    const el = document.getElementById('stat-stability');
    if (el) {
        // Fluctuation chaotique entre 10 et 15%
        const val = (Math.random() * (15 - 10) + 10).toFixed(1);
        el.innerText = val + "%";
        el.style.color = val < 11 ? "#f85149" : "#e6edf3";
    }
}, 2000);